import React from 'react';
import {
    Label
} from 'reactstrap';

export default function CustomLabel(props){
    return (
        <Label 
            
            style={{fontSize: '16px'}} 
            className="d-flex justify-content-sm-start h6" 
            sm={12}
            {...props}
        > 
             {props.children}                       
        </Label> 
    )
}